import Select from 'react-select';
import { NameFormatter } from '../formatters';
import { Link } from 'react-router-dom';

const SelectBox = ({
  label,
  name,
  isRequired,
  placeholder,
  handleSelect,
  options,
  optionKeys,
  errormsg,
  disabled,
  selectedOptions,
  nameFormatter,
  onScrollToBottom,
  isLoading,
  onSearch,
  fieldType,
  fieldId,
  styles,
  components,
  view,
}) => {
  let optionId = 'value';
  let optionValue = 'label';
  if (optionKeys && optionKeys.length > 1) {
    optionId = optionKeys[0];
    optionValue = optionKeys[1];
  } else {
    optionId = Object.keys(options[0])[0];
    optionValue = Object.keys(options[0])[1];
  }
  const isPlaceholder =
    typeof placeholder === 'string' && placeholder?.includes('Select') ? true : false;
  return (
    <>
      <label htmlFor={name}>
        {label}
        {isRequired && <span className="required-star">*</span>}
      </label>
      <div className="selectWd">
        {disabled && (fieldType === 'accountId' || (fieldType === 'contactId' && view)) ? (
          <Link
            to={`/${fieldType === 'accountId' ? 'accounts' : 'contacts'}/view${fieldType === 'accountId' ? 'Account' : 'Contact'}?id=${fieldId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {placeholder || '--'}
          </Link>
        ) : (
          <Select
            name={name}
            id={'selectbox-' + name}
            aria-labelledby={name}
            value={selectedOptions}
            onChange={(selectedOption) => handleSelect(selectedOption, name)}
            options={options?.map((data) => ({
              value: data[optionId],
              label: nameFormatter ? NameFormatter(data[optionValue]) : data[optionValue],
            }))}
            menuPortalTarget={document.body}
            isLoading={isLoading}
            onMenuScrollToBottom={onScrollToBottom}
            onInputChange={(value) => {
              if (onSearch) {
                onSearch(value);
              }
            }}
            menuShouldScrollIntoView={false}
            isDisabled={disabled}
            isPlaceholder={isPlaceholder}
            placeholder={placeholder}
            styles={
              styles
                ? styles
                : {
                    container: (base) => ({
                      ...base,
                      width: '100%',
                    }),
                    control: (base) => ({
                      ...base,
                      borderColor: errormsg ? 'red' : base.borderColor,
                    }),
                    placeholder: (provided, state) => ({
                      ...provided,
                      color: state.selectProps.isPlaceholder ? 'gray' : state.color,
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }
            }
            components={components ? components : <></>}
          />
        )}
        {errormsg && <div className="error-message">{errormsg}</div>}
      </div>
    </>
  );
};

export default SelectBox;
